import React from 'react'
import Subheader from '../../component/Subheader'
import ProcessContent from './ProcessContent'

export default function Process() {
    const subheadData = {
      image: '../image/process-banner.webp',
      heading: 'A Personalised Couture Process Made Just for You',
      pagename: 'Our Process',
    }

  return (
    <>
    <Subheader subheadData={subheadData}/>
    <ProcessContent/>
    </>
  )
}
